import { Component, computed, model } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { CerrixToggleButtonComponent } from "@app/shared/atoms/cerrix-toggle-button/cerrix-toggle-button.component";

@Component({
    selector: "cerrix-accept-reject-toggle",
    imports: [CerrixToggleButtonComponent, MatIcon],
    templateUrl: "./cerrix-accept-reject-toggle.component.html",
    styleUrl: "./cerrix-accept-reject-toggle.component.scss",
})
export class CerrixAcceptRejectToggleComponent {
    selection = model<boolean | null>(null);

    readonly isAcceptActive = computed(() => this.selection() === true);
    readonly isRejectActive = computed(() => this.selection() === false);

    select(value: boolean | null) {
        this.selection.update((curValue) => (curValue === value ? null : value));
    }
}
